import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import { ga4PromotionTracking } from '../ga4/promotion';
import type { IGaPromoData } from '../models/IGaPromoData';

const usePromotionTracking = ({
    gaPromoCreative,
    gaPromoId,
    gaPromoName,
    gaPromoPosition,
}: IGaPromoData) => {
    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.5,
    });

    useEffect(() => {
        if (inView) {
            ga4PromotionTracking.viewPromotion({
                gaPromoCreative,
                gaPromoId,
                gaPromoName,
                gaPromoPosition,
            });
        }
    }, [gaPromoCreative, gaPromoId, gaPromoName, gaPromoPosition, inView]);

    const click = () => {
        ga4PromotionTracking.selectPromotion({
            gaPromoCreative,
            gaPromoId,
            gaPromoName,
            gaPromoPosition,
        });
    };

    return { ref, click };
};

export default usePromotionTracking;
